import React from "react";

function EmptyPlaceholder(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="400px"
      height="400px"
      {...props}
      viewBox="0 0 512 512">
      <defs>
        <path
          id="path-1"
          d="M7.986 60.656L224.65 2.6c3.445-.923 4.79-.9 6.23-.563a7.27 7.27 0 013.703 2.138c1.011 1.08 1.705 2.232 2.628 5.677l58.055 216.664c.923 3.444.899 4.79.563 6.23a7.27 7.27 0 01-2.139 3.703c-1.079 1.011-2.231 1.704-5.676 2.627L71.35 297.132c-3.445.923-4.79.9-6.23.563a7.27 7.27 0 01-3.703-2.138c-1.011-1.079-1.705-2.232-2.628-5.676L.734 73.216c-.923-3.444-.899-4.79-.563-6.23a7.27 7.27 0 012.139-3.703c1.079-1.01 2.231-1.704 5.676-2.627z"></path>
        <filter id="filter-2" width="105.4%" height="105.4%" x="-2.7%" y="-2.4%" filterUnits="objectBoundingBox">
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5"></feGaussianBlur>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
        </filter>
        <path
          id="path-3"
          d="M243.35 2.6l216.664 58.056c3.445.923 4.597 1.616 5.676 2.627a7.27 7.27 0 012.139 3.704c.336 1.44.36 2.785-.563 6.23L409.21 289.88c-.923 3.444-1.617 4.597-2.628 5.676a7.27 7.27 0 01-3.703 2.138c-1.44.336-2.785.36-6.23-.563l-216.664-58.055c-3.445-.923-4.597-1.616-5.676-2.627a7.27 7.27 0 01-2.139-3.704c-.336-1.44-.36-2.785.563-6.23L230.79 9.854c.923-3.445 1.617-4.598 2.628-5.677a7.27 7.27 0 013.703-2.138c1.44-.336 2.785-.36 6.23.563z"></path>
        <filter id="filter-4" width="105.3%" height="105.3%" x="-2.7%" y="-2.3%" filterUnits="objectBoundingBox">
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5"></feGaussianBlur>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
        </filter>
        <path
          id="path-5"
          d="M360.744.5c3.567 0 4.86.371 6.163 1.069a7.27 7.27 0 013.024 3.024C370.63 5.896 371 7.189 371 10.756v253.488c0 3.567-.371 4.86-1.069 6.163a7.27 7.27 0 01-3.024 3.024c-1.303.698-2.596 1.069-6.163 1.069h-107.4L234 293.867 214.655 274.5h-107.4c-3.566 0-4.859-.371-6.162-1.069a7.27 7.27 0 01-3.024-3.024c-.698-1.303-1.069-2.596-1.069-6.163V10.756c0-3.567.371-4.86 1.069-6.163a7.27 7.27 0 013.024-3.024C102.396.87 103.689.5 107.256.5h253.488z"></path>
        <filter id="filter-6" width="107.3%" height="107.3%" x="-3.6%" y="-2.7%" filterUnits="objectBoundingBox">
          <feMorphology in="SourceAlpha" operator="dilate" radius="0.5" result="shadowSpreadOuter1"></feMorphology>
          <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
          <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="2.5"></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(22 107)">
          <g>
            <use fill="#000" filter="url(#filter-2)" xlinkHref="#path-1"></use>
            <use fill="#FFF" xlinkHref="#path-1"></use>
          </g>
          <g>
            <use fill="#000" filter="url(#filter-4)" xlinkHref="#path-3"></use>
            <use fill="#FFF" xlinkHref="#path-3"></use>
          </g>
          <g>
            <use fill="#000" filter="url(#filter-6)" xlinkHref="#path-5"></use>
            <use fill="#FFF" xlinkHref="#path-5"></use>
          </g>
          <path
            fill="#F7F7F7"
            d="M107.256 0h253.488c3.567 0 4.86.371 6.163 1.069a7.27 7.27 0 013.024 3.024C370.63 5.396 371 6.689 371 10.256V230H97V10.256c0-3.567.371-4.86 1.069-6.163a7.27 7.27 0 013.024-3.024C102.396.37 103.689 0 107.256 0z"></path>
        </g>
      </g>
    </svg>
  );
}

export default EmptyPlaceholder;